import React from 'react';
import { CondensedHeader, CondensedLarge } from '@axiom/ui';

export const SessionExpiryRefreshedToast = () => (
  <>
    <CondensedHeader>Your session has been refreshed</CondensedHeader>
    <CondensedLarge>
      Your session has been refreshed, no further action is required.
    </CondensedLarge>
  </>
);
